// Libs
import React, { Component } from 'react'
import axios from 'axios'

// CSS
import './styles.scss'

// Axios
import { serverAPI } from '../../index'

class ProfileIcon extends Component {
  state = {
    imageUrl: 'init'
  }

  componentDidMount() {
    const { image } = this.props
    const { fetchImage } = this

    fetchImage(image)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { image } = this.props
    const { image: nextImage } = nextProps
    const { fetchImage } = this

    if (image !== nextImage) {
      fetchImage(nextImage)
    }
  }

  fetchImage = (value) => {
    axios.get(value)
      .then(response => {
        this.setState({ imageUrl: value })
      })
      .catch(e => {
        this.setState({ imageUrl: '' })
      })
  }
  render() {
    const { width, fontSize, marginRight, lawyerName, companyName, image, ...props } = this.props
    const { imageUrl } = this.state
    const lawyerLetters = lawyerName ? lawyerName.toUpperCase().match(/\b(\w)/g) : []
    const companyLetters = companyName ? companyName.toUpperCase().match(/\b(\w)/g) : []

    const profileIconStyle = {
      width: `${width}px`,
      height: `${width}px`,
      marginRight: `${marginRight}px`,
      fontSize: `${fontSize}px`,
      backgroundImage: `url(${imageUrl})`
    }

    return (
      <div
        style={profileIconStyle}
        className={'profile-icon'}
        {...props}>
        {!imageUrl ? lawyerName && lawyerLetters[1] ? `${lawyerLetters[0]}${lawyerLetters[1]}` : lawyerLetters[0] : ''}
        {!imageUrl ? companyName && companyLetters[1] ? `${companyLetters[0]}${companyLetters[1]}` : companyLetters[0] : ''}
      </div>
    )
  }
}

export default ProfileIcon
